<template lang="pug">
  .tc Страница не найдена
</template>

<script>
export default {
  name: 'notFound'
};
</script>

<style lang="scss" scoped></style>
